var validateH5 = function validateH5() {
  // Currently there is no content checking for H5 files
};
export default validateH5;